import React, { useEffect, useState } from "react";

/**
 * It's a function that gets the styles from the URL and sets the styles to the state.
 * @returns An object with the following properties:
 * style: "default",
 * color: "color-default",
 * buttonbg: "0000ff",
 * buttonColor: "fff",
 * inputColor: "212529",
 * inputbg: "fff",
 * selectbg: "fff",
 * inputBorde: "1px solid #ced4da
 */
const useGetStyles = () => {
    const [styles, setStyles] = useState({
        style: "default",
        color: "color-default",
        buttonbg: "0000ff",
        buttonColor: "fff",
        inputColor: "212529",
        inputbg: "fff",
        selectbg: "fff",
        inputBorde: "1px solid #ced4da",
        btnposition: "text-center",
        inline: false,
        showlabel: true,
    });

    const backgroundUrl = new URLSearchParams(location.search).get(
        "background"
    );

    const getUrlParam = (param) => {
        return new URLSearchParams(location.search).get(param);
    };

    useEffect(() => {
        document.body.style.background = "transparent";

        const newStyles = {
            style: getUrlParam("style") ? getUrlParam("style") : styles.style,
            color: getUrlParam("color") ? getUrlParam("color") : styles.color,
            buttonbg: getUrlParam("buttonbg")
                ? getUrlParam("buttonbg")
                : styles.buttonbg,
            buttonColor: getUrlParam("buttonColor")
                ? getUrlParam("buttonColor")
                : styles.buttonColor,
            inputColor: getUrlParam("inputcolor")
                ? getUrlParam("inputcolor")
                : styles.inputColor,
            inputbg: getUrlParam("inputbg")
                ? getUrlParam("inputbg")
                : styles.inputbg,
            selectbg: getUrlParam("selectbg")
                ? getUrlParam("selectbg")
                : styles.selectbg,
            inputBorde: getUrlParam("inputBorde")
                ? getUrlParam("inputBorde")
                : styles.inputBorde,
            btnposition: getUrlParam("btnposition")
                ? getUrlParam("btnposition")
                : styles.btnposition,
            inline: getUrlParam("inline")
                ? getUrlParam("inline")
                : styles.inline,
            showlabel: getUrlParam("showlabel")
                ? getUrlParam("showlabel")
                : styles.showlabel,
        };

        setStyles(newStyles);

        if (backgroundUrl == "transparent") {
            document.body.style.background = "transparent";
        } else {
            document.body.style.background = "#" + backgroundUrl;
        }
        document.getElementById("loading").style.display = "none";
    }, []);

    return styles;
};
export default useGetStyles;
